export default "__VITE_PUBLIC_ASSET__2ed9bcf0__"